import './no-match.css';

function NoMatch() {
  return (
    <div className="no-match">NoMatch</div>
  );
}

export default NoMatch;
